import * as Yup from "yup";

export const FundName = Yup.object({
  name: Yup.string().min(1).max(30).required("Fund name is required"),
  abbreviation: Yup.string()
    .min(1)
    .max(30)
    .required("Abbreviation is required"),
});
export const SMAName = Yup.object({
  name: Yup.string().min(1).max(30).required("Fund name is required"),
  abbreviation: Yup.string()
    .min(1)
    .max(30)
    .required("Abbreviation is required"),
  account: Yup.string()
    .required("Account is required")
    .min(1, "Account cannot be empty"),
  addeparAccountId: Yup.string()
    .required("Addepar Account ID is required")
    .min(1, "Addepar Account ID cannot be empty"),
});